/**
 * App bots (Docubot, etc.) must not appear as OmmnioSign signers.
 * In a 1:1 with an app, `channel.isApp` is set on the DM and the counterpart
 * member is built from `channel._id` without `user.isApp`.
 *
 * @param {Array<{ user?: { _id?: string, isApp?: boolean }, isApp?: boolean, _id?: string }>} members
 * @param {{ isAppChannel?: boolean, channelId?: string }} [opts]
 * @returns {typeof members}
 */
export default function excludeAppChannelMembers(members = [], opts = {}) {
  const { isAppChannel = false, channelId } = opts;
  const channelIdStr = channelId != null ? String(channelId) : '';
  return members.filter(member => {
    if (!member) return false;
    if (member.user?.isApp || member.isApp) return false;
    if (isAppChannel && channelIdStr) {
      const memberUserId = member.user?._id != null ? String(member.user._id) : '';
      const memberId = member._id != null ? String(member._id) : '';
      if (memberUserId === channelIdStr || memberId === channelIdStr) {
        return false;
      }
    }
    return true;
  });
}
